"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var project = [{
        path: '/project',
        meta: {
            title: "项目列表"
        },
        component: function () { return Promise.resolve().then(function () { return require("@/views/project/list.vue"); }); }
    }];
exports.default = project;
